import { forwardRef } from 'react';
import NumberFormat from 'react-number-format';
import { InputFormatProps } from '../types';

const PhoneNumberFormat = forwardRef<NumberFormat, InputFormatProps>(
  ({ field }, ref) => {
    const { onChange, value, ...rest } = field;
    return (
      <NumberFormat
        value={value}
        {...rest}
        ref={ref}
        className='block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm placeholder-gray-300 focus:outline-none'
        format='+1 (###) ###-####'
        placeholder='+1 (000)-000-0000'
        isNumericString
        onValueChange={(target) => {
          onChange(target.floatValue);
        }}
      />
    );
  }
);

export default PhoneNumberFormat;
